import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import cellStyles from "@components/history/views/cells/Cell.module.scss";
import { OrganizationActivityActor } from "../OrganizationActivityActor";
import { OrganizationActivityRow } from "../organizationActivityRow";

export const ActorCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, OrganizationActivityRow, unknown>) => (
        <ViewTableCell className={cellStyles.updatedByCell}>
            <OrganizationActivityActor row={row.original} />
        </ViewTableCell>
    ),
);

ActorCell.displayName = "ActorCell";
